import React, { useState } from 'react'
import Panel from './Panel'
import { Risk } from '../model/Risk';
import { riskLevel } from './AnalyseCalc';
import BalancePDF from '../PDF/BalancePDF';
import { PDFDownloadLink } from '@react-pdf/renderer';

export interface BalanceData {
    processingPurpose?: string;
    addValue?: string;
    isBusinessReal: boolean;
    businessReal?: string;
    isAnyOtherJustification: boolean;
    otherJustification?: string;
    isProcessingNecessary: boolean;
    processingNecessary?: string;
    isAllDataNecessary: boolean;
    allDataNecessary?: string;
    isSaveTimeExceed: boolean;
    saveTimeExceed?: string;
    isGoalAchievedWithout: boolean;
    goalAchievedWithout?: string;
    personalDataKind?: string;
    personalDataCategory?: string;
    dataOrigin?: string;
    personalExpectations?: string;
    processingCharacter?: string;
    isPositiveImpact: boolean;
    positiveImpact?: string;
    isNegativeImpact: boolean;
    negativeImpact?: string;
    isPersonalControl: boolean;
    personalControl?: string;
    isPersonInformed: boolean;
    personInformed?: string;
    risks: Risk[];
    isAdminBusiness: boolean;
    adminBusiness?: string;
    adminDecision?: string;
}

const riskName = (value: number) => {
    if(value == 1) return "Małe";
    if(value == 2) return "Średnie";
    if(value == 3) return "Duże";
    if(value == 4) return "Bardzo duże";
  }

export default function BalanceCalc() {

  const [data, setData] = useState<BalanceData>({
    isBusinessReal: false,
    isAnyOtherJustification: false,
    isAllDataNecessary: false,
    isGoalAchievedWithout: false,
    isProcessingNecessary: false,
    isSaveTimeExceed: false,
    isPositiveImpact: false,
    isNegativeImpact: false,
    isPersonalControl: false,
    isPersonInformed: false,
    isAdminBusiness: false,
    risks: [{
        name: '',
        effect: 1,
        id: 1, 
        probability: 1,
        recommendations: '',
        risk: '',
        source: '',
        wayOfDeal: '',
        weight: 1
    }]
  })

  const newRisk = (id: number): Risk => {
        return {
            name: '',
            effect: 1,
            id: id,
            probability: 1,
            recommendations: '',
            risk: '',
            source: '',
            wayOfDeal: '',
            weight: 1
        }
    }

    const addNewDanger = () => {
        const newId = data.risks.reduce((a, b) => Math.max(a, b.id), 0);
        setData({...data, risks: [...data.risks, newRisk(newId + 1)]})
    }

    const changeValue = (field: string, event: any) => {
        const newData = {
            ...data,
            [field]: event.target.value
        };

        setData(newData);
    }

    const changeRisk = (id: number, prop: string, e: any) => {
        const newRisk = data.risks.map(x => {
          if(x.id !== id) return x;
    
          return ({
            ...x,
            [prop]: e.target.value
          })
        })
    
        setData({...data, risks: newRisk})
      }

    const checkValue = (field: string, event: any) => {
        const newData = {
            ...data,
            [field]: event.target.checked
        }
        setData(newData);
    }

    const document = () => {
            return (
                <BalancePDF {...data} />
            )
          }

  return (
    <div>
        <div className='row'>
            <div className='col text-center'>
                <h3 className='text-dark-gray fw-700 ls-minus-1px'>Test równowagi</h3>
            </div>
        </div>
        <div className='row'>
            <Panel header="1. Test celu">
                <div>
                    <label className='text-medium-gray mb-10px'>Jaki jest cel przetwarzania?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.processingPurpose} onChange={e => changeValue("processingPurpose", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Jakie korzyści Administrator zamierza osiągnąć z przetwarzania danych osobowych??</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.addValue} onChange={e => changeValue("addValue", e)} />
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isBusinessReal", e)} checked={data.isBusinessReal} />Czy interes ten jest rzeczywisty i aktualny</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.businessReal} onChange={e => changeValue("businessReal", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isAnyOtherJustification", e)} checked={data.isAnyOtherJustification} />Czy są inne podstawy przetwarzania, na których można oprzeć przetwarzanie</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.otherJustification} onChange={e => changeValue("otherJustification", e)} /> 
                    </div>
                </div>
            </Panel>

            <Panel header="2. Test niezbędności">
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isProcessingNecessary", e)} checked={data.isProcessingNecessary} />Czy przetwarzanie jest koniecznie w celu realizacji uzasadnionego interesu</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.processingNecessary} onChange={e => changeValue("processingNecessary", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isAllDataNecessary", e)} checked={data.isAllDataNecessary} />Czy wszystkie dane są niezbędne dla wskazanego celu</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.allDataNecessary} onChange={e => changeValue("allDataNecessary", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isSaveTimeExceed", e)} checked={data.isSaveTimeExceed} />Czy okres przechowywania nie wykracza poza to, co niezbędne</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.saveTimeExceed} onChange={e => changeValue("saveTimeExceed", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isGoalAchievedWithout", e)} checked={data.isGoalAchievedWithout} />Czy można osiągnąć dany cel bez przetwarzania danych lub innymi środkami, które mniej ingerują w prywatność osoby, której dane dotyczą</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.goalAchievedWithout} onChange={e => changeValue("goalAchievedWithout", e)} /> 
                    </div>
                </div>
            </Panel>
            <Panel header='3. Test równowagi'>
                <div>
                    <label className='text-medium-gray mb-10px'>Jakie rodzaje danych osobowych będą przetwarzane w danym procesie?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.personalDataKind} onChange={e => changeValue("personalDataKind", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Jakie kategorie osób będą przetwarzane w danym procesie? Czy są wśród nich dzieci lub inne osoby wymagające szczególnej opieki?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.personalDataCategory} onChange={e => changeValue("personalDataCategory", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Skąd pochodzą dane osobowe</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.dataOrigin} onChange={e => changeValue("dataOrigin", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Czy osoba, której dane dotyczą, ma rozsądne oczekiwania wobec przetwarzania?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.personalExpectations} onChange={e => changeValue("personalExpectations", e)} />
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Jaki jest charakter przetwarzania danych osobowych?</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.processingCharacter} onChange={e => changeValue("processingCharacter", e)} />
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isPositiveImpact", e)} checked={data.isPositiveImpact} />Czy przetwarzanie może mieć pozytywny wpływ na osobę</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.positiveImpact} onChange={e => changeValue("positiveImpact", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isNegativeImpact", e)} checked={data.isNegativeImpact} />Czy przetwarzanie może mieć negatywny wpływ na osobę? Jakie są zagrożenia dla interesów lub praw i wolności osoby</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.negativeImpact} onChange={e => changeValue("negativeImpact", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isPersonalControl", e)} checked={data.isPersonalControl} />Czy osoba, której dane dotyczą, ma kontrolę nad swoimi danymi</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.personalControl} onChange={e => changeValue("personalControl", e)} /> 
                    </div>
                </div>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isPersonInformed", e)} checked={data.isPersonInformed} />Czy osoba, której dane dotyczą, jest przejrzyście informowana o prawnie uzasadnionym interesie Administratora</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.personInformed} onChange={e => changeValue("personInformed", e)} /> 
                    </div>
                </div>
            </Panel>
            <Panel header="4. Analiza ryzyka">
                <div className='row mb-15px'>
                    <div>
                        {data.risks.map((x, i) => {
                            return (
                                <div key={x.id} className={`row mb-15px ${i !== data.risks.length - 1 ? "border-bottom border-2 border-color-gray" : ""}`}>
                                    <div className='col-lg-12'>
                                        <div className='progress-bar-style-02'>
                                            <div className='progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white'>
                                                <div className="progress-bar bg-gradient-flamingo-red-transparent m-0 appear" role="progressbar" aria-valuenow={98} aria-valuemin={0} aria-valuemax={100} aria-label="business" style={{width: riskLevel(x).value}} />
                                                <div className="progress-bar-title text-uppercase">{riskLevel(x).text}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <label className='text-medium-gray mb-10px'>Naruszenie</label>
                                        <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={x.name} onChange={e => changeRisk(x.id, "name", e)} />
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="text-medium-gray">Prawdopodobieństwo - {riskName(x.probability)}</label>
                                        <input type="range" className='calc-range' min="1" max="4" step="1" value={x.probability} onChange={e => changeRisk(x.id, "probability", e)} />
                                    </div>
                                    <div className="col-lg-3">
                                        <label className="text-medium-gray">Skutki - {riskName(x.effect)}</label>
                                        <input type="range" className='calc-range' min="1" max="4" step="1" value={x.effect} onChange={e => changeRisk(x.id, "effect", e)} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="row" style={{ marginTop: "1.0rem"}}>
                        <div className="col">
                            <button type="button" className="btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font" onClick={addNewDanger}>Dodaj</button>
                        </div>
                    </div>
                </div>
            </Panel>
            <Panel header='5. Wynik testu'>
                <div className='mb-2 mt-4 pb-2 border-bottom flex-lg'>
                    <div className='form-check col'>
                        <label className="text-medium-gray mb-10px checkbox"><input className="form-check-input" type="checkbox" onChange={e => checkValue("isAdminBusiness", e)} checked={data.isAdminBusiness} />Czy interes administratora przeważa</label>
                    </div>
                    <div className='col-lg-6'>
                        <input className="form-control" type="text" placeholder="Opis (opcja)" value={data.adminBusiness} onChange={e => changeValue("adminBusiness", e)} /> 
                    </div>
                </div>
                <div>
                    <label className='text-medium-gray mb-10px'>Decyzja administratora</label>
                    <textarea className="form-control danger-text form-control border-white fs-16 box-shadow-large mb-10px" rows={3} value={data.adminDecision} onChange={e => changeValue("adminDecision", e)} />
                </div>
            </Panel>
        </div>
        <div className="row text-right">
            <div className='calc-pdf-btn'>
                <PDFDownloadLink className='btn btn-medium btn-dark-gray btn-box-shadow btn-round-edge text-transform-none primary-font submit' document={document()}>Zapisz do pliku PDF</PDFDownloadLink>
            </div>
        </div>
    </div>
  )
  
}